"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStatusToJSON = exports.CustomerStatusFromJSONTyped = exports.CustomerStatusFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CustomerStatusFromJSON(json) {
    return CustomerStatusFromJSONTyped(json, false);
}
exports.CustomerStatusFromJSON = CustomerStatusFromJSON;
function CustomerStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'news': (0, _1.CustomerStatusNewsFromJSON)(json['news']),
        'maturities': (0, _1.MaturitiesFromJSON)(json['maturities']),
        'returns': !(0, runtime_1.exists)(json, 'returns') ? undefined : (0, _1.CustomerStatusReturnsFromJSON)(json['returns']),
        'shipments': !(0, runtime_1.exists)(json, 'shipments') ? undefined : (json['shipments'].map(_1.CustomerStatusShipmentsFromJSON)),
        'prepaymentHint': !(0, runtime_1.exists)(json, 'prepaymentHint') ? undefined : (0, _1.CustomerStatusPrepaymentHintFromJSON)(json['prepaymentHint']),
        'advantages': !(0, runtime_1.exists)(json, 'advantages') ? undefined : (0, _1.CustomerStatusAdvantagesFromJSON)(json['advantages']),
        'premiumStatus': !(0, runtime_1.exists)(json, 'premiumStatus') ? undefined : (0, _1.CustomerStatusPremiumStatusFromJSON)(json['premiumStatus']),
    };
}
exports.CustomerStatusFromJSONTyped = CustomerStatusFromJSONTyped;
function CustomerStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'news': (0, _1.CustomerStatusNewsToJSON)(value.news),
        'maturities': (0, _1.MaturitiesToJSON)(value.maturities),
        'returns': (0, _1.CustomerStatusReturnsToJSON)(value.returns),
        'shipments': value.shipments === undefined ? undefined : (value.shipments.map(_1.CustomerStatusShipmentsToJSON)),
        'prepaymentHint': (0, _1.CustomerStatusPrepaymentHintToJSON)(value.prepaymentHint),
        'advantages': (0, _1.CustomerStatusAdvantagesToJSON)(value.advantages),
        'premiumStatus': (0, _1.CustomerStatusPremiumStatusToJSON)(value.premiumStatus),
    };
}
exports.CustomerStatusToJSON = CustomerStatusToJSON;
//# sourceMappingURL=CustomerStatus.js.map